import store from '../../vuex/store'

let imgList = []
export const directive = {
  inserted: function (el, {value}) {
    imgList = value ? value.split(',') : []
    el.addEventListener('click', handler.handleImageWrapperClick, false)
  },
  update (el, {value}) {
    imgList = value ? value.split(',') : []
  },
  unbind (el) {
    el && el.removeEventListener('click', handler.handleImageWrapperClick, false)
  }
}

export const handler = {
  handleImageWrapperClick (e) {
    if (e.target.tagName.toLowerCase() === 'img') {
      showImagePreviewer({srcList: imgList, currSrc: e.target.src})
    }
  }
}

export const showImagePreviewer = function ({srcList, currSrc}) {
  store.commit('setImgForPreview', {imgSrcNeedToPreview: srcList, currImgNeedToPreview: currSrc, needShowImgPreviewCommon: true})
  // store.commit('setSomeState', {currImgNeedToPreview: currSrc})
  // store.commit('setSomeState', {needShowImgPreviewCommon: true})
}

export default directive



// WEBPACK FOOTER //
// ./src/components/dialog-image-preview-common/image-preview.js